var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",staticStyle:{"width":"100%"},style:({
    height: _vm.height,
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }